var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSharediabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sharediabled"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30301",
    "data-name": "Rectangle 30301",
    width: 24,
    height: 24,
    transform: "translate(394 688)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_867",
    "data-name": "Mask Group 867",
    transform: "translate(-394 -688)",
    clipPath: "url(#sharediabled)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-08-22T152617.550",
    "data-name": "svgexport-6 - 2022-08-22T152617.550",
    transform: "translate(392.286 686.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47992",
    "data-name": "Path 47992",
    d: "M7.714,20.571H4.286A2.571,2.571,0,0,1,1.714,18V6.857A2.572,2.572,0,0,1,4.286,4.286H23.143a2.571,2.571,0,0,1,2.571,2.571V18a2.571,2.571,0,0,1-2.571,2.571H19.714v.668a1.9,1.9,0,0,1-1.9,1.9H9.618a1.9,1.9,0,0,1-1.9-1.9Zm1.714,0v.668a.189.189,0,0,0,.189.189h8.193A.189.189,0,0,0,18,21.239v-.668ZM12.857,11.5l-.961.961a.857.857,0,0,1-1.212-1.212l2.424-2.424a.857.857,0,0,1,1.212,0l2.424,2.424a.857.857,0,1,1-1.212,1.212l-.961-.961v3.931a.857.857,0,1,1-1.714,0Z",
    fill: "#382464"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon_close",
    "data-name": "icon/close",
    transform: "translate(395.707 689.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_Stroke_",
    "data-name": "Vector (Stroke)",
    d: "M.764.131,3,2.367,5.236.131a.447.447,0,1,1,.633.633L3.633,3,5.869,5.236a.447.447,0,0,1-.633.633L3,3.633.764,5.869a.447.447,0,0,1-.633-.633L2.367,3,.131.764A.447.447,0,0,1,.764.131Z",
    transform: "translate(7.293 6.293)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharediabled);
export default __webpack_public_path__ + "static/media/sharediabled.8b681798c521d93073825647a9bad31d.svg";
export { ForwardRef as ReactComponent };